import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import '../../index.scss';
import { CalendarStateProvider } from 'context/CalendarContext';
import CalendarView from './index';
import { GlobalToast } from 'components/GlobalToast';
var CalendarViewContainer = function () { return (_jsxs(_Fragment, { children: [_jsx(CalendarStateProvider, { children: _jsx(CalendarView, {}) }), _jsx(GlobalToast, {})] })); };
export default CalendarViewContainer;
